import { SkuDetailSection, SkuParamListener } from '../../../domain/models/SkuDetail';
import { AnimationType } from '../../../presentation/constants/AnimationType';
import { SkuButtonFlowListener } from '../SkuDetailFlowButtons';
import { SkuInputAmount } from '../SkuInputAmount';
import { SkuInputTextWithConfirmation } from '../SkuInputTextWithConfirmation';
import { SkuLabelTitle } from '../SkuLabelTitle';
import { SkuMessageInfo } from '../SkuMessageInfo';
import { SkuMessageWarn } from '../SkuMessageWarn';
import { SkuSelectAmount } from '../SkuSelectAmount';
import { SkuSelectAmountWithDetail } from '../SkuSelectAmountWithDetail';
import { RequestParam } from '../../../domain/models/RequestParam';
import { SkuLabelTicket } from '../SkuLabelTicket';
import { SkuMessageError } from '../SkuMessageError';
import { SkuModalSection } from '../../../domain/constants/SkuModalSection';
import { SkuWebComponent } from '../../../domain/constants/SkuWebComponent';
import { SkuClientBalance } from '../SkuClientBalance';
import { SkuInputQR } from '../SkuInputQR';
import { SkuActivationInfo } from '../SkuActivationInfo';
export class SkuProcessEngine {
    static getBodyElements(sections: SkuDetailSection[]) {
        const excluded: string[] = [SkuWebComponent.MessageInfo,
        SkuWebComponent.MessageWarn,
        SkuWebComponent.InputHidden];
        return sections.filter((section) => {
            return section.modalSection === SkuModalSection.Body && !excluded.includes(section.webComponent)
        });
    }

    static getTicketBodyElements(sections: SkuDetailSection[]) {

        return sections.filter((section) => {
            return section.modalSection === SkuModalSection.Body
        })
    }

    static getHeaderComponents(sections: SkuDetailSection[]) {

        return sections.filter((section) => {
            return section.modalSection === SkuModalSection.Head
        }).map((e) => {
            return this.getComponent(e);
        });
    }

    static getAllMessagesComponents(sections: SkuDetailSection[]) {

        return sections.filter((section) => {
            return section.webComponent === SkuWebComponent.MessageInfo ||
                section.webComponent === SkuWebComponent.MessageWarn
        }).map((e) => {
            return this.getComponent(e);
        })
    }

    static getHiddenParams(sections: SkuDetailSection[]) {

        return sections.filter((e) => {
            return e.webComponent === SkuWebComponent.InputHidden
        }).map((e) => {
            return new RequestParam(`${e.param}`, `${e.webValue}`, ``, true);
        })
    }

    //[Balance Step 7]: Devuelve todos los componentes de tipo BalanceInfo para renderizar el saldo del cliente en el modal.
    static getAllBalanceComponents(sections: SkuDetailSection[]) {
        return sections
            .filter((section) => section.webComponent === SkuWebComponent.BalanceInfo)
            .map((section) => this.getComponent(section));
    }

    private static filterComponents(
        sections: SkuDetailSection[],
        modalSection: SkuModalSection,
        excludeWebComponents: string[] = []) {
        return sections.filter((section) => {
            return section.modalSection === modalSection && !excludeWebComponents.includes(section.webComponent)
        });
    }

    static getComponent(

        skuSection: SkuDetailSection,
        buttonFlowListener?: SkuButtonFlowListener,
        skuParamListener?: SkuParamListener, animType: AnimationType = AnimationType.NONE) {


        const webComponent = skuSection.webComponent;

        switch (webComponent) {

            case SkuWebComponent.LabelTitle:


                return (<SkuLabelTitle title={`${skuSection.webValue}`} />);

            case SkuWebComponent.LabelTicket:


                return (<SkuLabelTicket label={`${skuSection.webLabel}`} value={`${skuSection.webValue}`} />);

            // ==== MESSAGES   
            case SkuWebComponent.MessageInfoTicket:


                return (
                    <SkuMessageInfo message={(`${skuSection.webValue}`)}
                    />
                );
            case SkuWebComponent.MessageInfo:


                return (
                    <SkuMessageInfo message={(`${skuSection.webValue}`)} />
                );

            //[Balance Step 8]: Renderiza el componente SkuClientBalance cuando el webComponent es BalanceInfo.
            case SkuWebComponent.BalanceInfo:
                return (
                    <SkuClientBalance web_label={(`${skuSection.webLabel}`)} />
                );

            case SkuWebComponent.MessageWarn:

                return (
                    <SkuMessageWarn message={(`${skuSection.webValue}`)} />
                );

            case SkuWebComponent.MessageError:


                return (
                    <SkuMessageError message={(`${skuSection.webValue}`)} />
                )

            // case SkuWebComponent.BalanceInfo:
            //     return (
            //         <SkuMessageInfo message={('')} />
            //     )

            //INPUTS
            case SkuWebComponent.InputTextWithConfirmation:

                return (<SkuInputTextWithConfirmation
                    constraints={skuSection.constraints}
                    label={skuSection.webLabel}
                    nameParam={skuSection.param}
                    skuParamListener={skuParamListener}
                    buttonFlowListener={buttonFlowListener}
                    animationType={animType} />);

            case SkuWebComponent.InputTextWithConfirmationUppercase:


                return (<SkuInputTextWithConfirmation
                    constraints={skuSection.constraints}
                    label={skuSection.webLabel}
                    nameParam={skuSection.param}
                    skuParamListener={skuParamListener}
                    buttonFlowListener={buttonFlowListener}
                    animationType={animType}
                    uppercase={true} />);

            case SkuWebComponent.InputAmount:


                return (
                    <SkuInputAmount
                        nameParam={skuSection.param ?? "amount"}
                        maxAmount={skuSection.constraints?.maxAmount}
                        minAmount={skuSection.constraints?.minAmount}
                        skuParamListener={skuParamListener}
                        buttonFlowListener={buttonFlowListener}
                        animationType={animType}
                        initialAmount={skuSection.webValue}
                        disabled={true}
                    />
                );
            case SkuWebComponent.InputAmountReceipt:


                return (
                    <SkuInputAmount
                        nameParam={skuSection.param ?? "amount"}
                        maxAmount={skuSection.constraints?.maxAmount}
                        minAmount={skuSection.constraints?.minAmount}
                        skuParamListener={skuParamListener}
                        buttonFlowListener={buttonFlowListener}
                        animationType={animType}
                    />
                );

            // ==== OPTIONS
            case SkuWebComponent.SelectAmount:


                return (
                    <SkuSelectAmount
                        nameParam={skuSection.param ?? "amount"}
                        amounts={(skuSection.webValue as number[]) ?? []}
                        skuParamListener={skuParamListener}
                        buttonFlowListener={buttonFlowListener}
                        animationType={animType} />
                )

            // ==== OPTIONS
            case SkuWebComponent.SelectAmountWithDetail:

                return (
                    <SkuSelectAmountWithDetail
                        nameParam={skuSection.param ?? "amount"}
                        amounts={(skuSection.webValue as object[]) ?? []}
                        skuParamListener={skuParamListener}
                        buttonFlowListener={buttonFlowListener}
                        animationType={animType} />
                )

            // ==== HIDDEN
            case SkuWebComponent.InputHidden:
                return (<></>);

            // ==== COMPONENTE QR
            case SkuWebComponent.InputQR:
                return (
                    <SkuInputQR
                        label={skuSection.webLabel}
                        nameParam={skuSection.param ?? 'ref'}
                        placeholder={String(skuSection.webValue ?? '')}
                        buttonFlowListener={buttonFlowListener}
                        skuParamListener={skuParamListener}
                        required={true}
                    />
                );

            // ==== INFORMACIÓN DE ACTIVACIÓN QR
            case SkuWebComponent.ActivationInfo:
                return (
                    <SkuActivationInfo
                        meta={skuSection.webValue as any}
                    />
                );

            default:
                return (<div>{skuSection.webComponent}</div>)
        }
    }

}